import { useTranslation } from '@lyearn/i18n';
import LearnerActionModal from '@/modules/learner/components/LearnerActionModal';

import { LearnerDeactivateModalProps } from './types';

const LearnerDeactivateModal: React.FC<LearnerDeactivateModalProps> = (props) => {
  const { learner, onClose, onSubmit, onRemoveStaff } = props;

  const { t } = useTranslation();

  const removeStaffProps = {
    discardText: t('Admin:LearnerAndGroups.RemoveStaff'),
    onSecondarySubmit: onRemoveStaff,
  };

  return (
    <LearnerActionModal
      action={{
        label: t('Common:Actions.Deactivate'),
        appearance: 'danger',
        onClick: onSubmit,
        ...(learner.isStaff && removeStaffProps),
      }}
      header={{
        title: t('Admin:LearnerAndGroups.DeactivateAccount'),
        description: t('Admin:LearnerAndGroups.DeactivateAccountDescriptionLearner'),
      }}
      learner={learner}
      onClose={onClose}
    />
  );
};

export default LearnerDeactivateModal;
